if (!customElements.get('fsk-product-recommendations')) {
  customElements.define('fsk-product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.observer || this.controller) return;
      if (this.dataset.performed === 'true') {
        this.loaded = true;
        return;
      }
      if (!('IntersectionObserver' in window)) {
        this.loadRecommendations();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.observer = null;
        this.loadRecommendations();
      }, { rootMargin: '400px 0px', threshold: 0 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.controller?.abort();
    }

    async loadRecommendations() {
      if (this.loaded || this.controller || !this.dataset.url) return;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin) return;
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          signal: controller.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) return;
        const html = await response.text();
        if (!this.isConnected || controller.signal.aborted) return;
        const document = new DOMParser().parseFromString(html, 'text/html');
        const incoming = Array.from(document.querySelectorAll('fsk-product-recommendations')).find(element =>
          element.dataset.productId === this.dataset.productId && element.dataset.section === this.dataset.section
        );
        if (!incoming || incoming.dataset.performed !== 'true') return;
        if (incoming.querySelector('.fskdp__related-card a[href]')) {
          this.innerHTML = incoming.innerHTML;
          this.dataset.state = 'ready';
        } else {
          this.dataset.state = this.querySelector('.fskdp__related-card') ? 'ready' : 'empty';
        }
      } catch {
      } finally {
        window.clearTimeout(timeout);
        if (this.controller === controller) this.controller = null;
        this.loaded = this.isConnected;
      }
    }
  });
}
